import {
  Box,
  createTheme,
  ThemeProvider,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Image from 'mui-image';

import {Singin} from '../../components/auth/Singin';
import {AuthLayout} from '../../layouts/AuthLayout';
import {LOGO} from '../../utils/logo';

const loginLightTheme = createTheme({
  palette: {mode: 'light', primary: {main: '#0c2646'}},
  components: {
    // White input fill so the fields stand out against the cream panel
    MuiOutlinedInput: {
      styleOverrides: {
        root: {backgroundColor: '#fff'},
      },
    },
  },
});

export const SigninPage = () => {
  const theme = useTheme();
  const showLeftPanel = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <AuthLayout variant="split">
      <Box display="flex" height="100%">
        {/* ── Left gradient panel ── */}
        {showLeftPanel && (
          <Box
            flex="1 1 58%"
            display="flex"
            flexDirection="column"
            sx={{
              background:
                'linear-gradient(160deg, #0c2646 0%, #143a68 60%, #00a6e2 100%)',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Logo (mountain icon + wordmark) — upper left, same pairing as the dashboard header */}
            <Box sx={{p: 4}} display="flex" columnGap="4px" alignItems="center">
              <Image
                height={56}
                width="auto"
                src={LOGO.white_top}
                duration={0}
              />
              <Image height={34} width="auto" src={LOGO.white} duration={0} />
            </Box>

            {/* Headline + paragraph — vertically centred in remaining space */}
            <Box
              flex={1}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              sx={{px: 6, pb: 8}}
            >
              <Typography
                variant="h2"
                sx={{
                  color: '#fff',
                  fontSize: {xs: 52, md: 72, lg: 84},
                  lineHeight: 1.15,
                  mb: 3,
                }}
              >
                Where{' '}
                <Box
                  component="span"
                  sx={{color: (t) => t.palette.primary.light ?? '#00a6e2'}}
                >
                  /safety
                </Box>{' '}
                <Box style={{whiteSpace: 'pre-line'}}>is success.</Box>
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(255,255,255,0.75)',
                  fontSize: {xs: 16, md: 18, lg: 20},
                  maxWidth: 440,
                  lineHeight: 1.65,
                }}
              >
                Real-time detection data, zone-aware analytics and on-demand
                report generation across every vehicle and every site — operated
                as one.
              </Typography>
            </Box>
          </Box>
        )}

        {/* ── Right form panel ── */}
        <Box
          flex={showLeftPanel ? '1 1 42%' : '1 1 100%'}
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            backgroundColor: '#F5F0EA',
            px: {xs: 2, sm: 4},
          }}
        >
          <ThemeProvider theme={loginLightTheme}>
            <Singin />
          </ThemeProvider>
        </Box>
      </Box>
    </AuthLayout>
  );
};
